import React, { useState, useEffect } from 'react';
import { getClassNameFactory } from '@dcl/ui';
import './MetaDataList.css';
import { IMetaDataList } from '../../types';

export const MetaDataList: React.FC<IMetaDataList> = (props) => {
  const { text, value } = props;
  const [showButton, setShowButton] = React.useState(false);
  const getClassName = getClassNameFactory(MetaDataList.displayName);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const listData = value.split(',');
    listData.length > 2 ? setShowButton(true) : setShowButton(false);
  }, [value]);
  const toggleContent = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className={getClassName()}>
      <li className={getClassName({ descendantName: 'list' })}>
        <span className={getClassName({ descendantName: 'title' })}>
          {text}:{' '}
        </span>

        <span className={getClassName({ descendantName: 'content' })}>
          {isExpanded
            ? value.split(',').join(', ')
            : value.split(',').slice(0, 2).join(', ')}
        </span>
        {showButton && (
          <button
            className={getClassName({ descendantName: 'buttonMoreLess' })}
            onClick={toggleContent}
          >
            {isExpanded ? 'Show Less' : 'Show More'}
          </button>
        )}
      </li>
    </div>
  );
};

MetaDataList.displayName = 'MetaDataList';
